<template>
  <div class="hero-slider">
    <swiper :options="swiperOption">
      <swiper-slide class="featured-dorms__col col-xl-3 col-lg-3 col-md-4"
        v-for="item in items"
        :key="item.id">
        <div class="hero-slider__item" v-on:click="openDorm(item.id, item.slug)">
          <img :src="'http://image.tmdb.org/t/p/w185/' + item.poster_path" alt="" class="hero-slider__logo">
          <div class="hero-slider__title" v-if="!item.branch_count > 0 && !item.center_slug">{{ item.name }}</div>
          <div class="hero-slider__title" v-if="item.branch_count > 0 && item.center_slug">{{ item.center_name }}</div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'HeroSlider',
  data () {
    return {
      center_name: null,
      dorm: null,
      items1: [],
      swiperOption: {
        centeredSlides: false,
        slidesPerGroup: 4,
        spaceBetween: 0,
        slidesPerView: 4,
        breakpoints: {
          768: {
            spaceBetween: 10,
            slidesPerGroup: 3,
            slidesPerView: 3,
            centeredSlides: false
          },
          640: {
            slidesPerView: 1,
            centeredSlides: true,
            slidesPerGroup: 1,
            spaceBetween: 10
          },
          320: {
            slidesPerView: 'auto',
            centeredSlides: true,
            slidesPerGroup: 1

          }
        },
        simulateTouch: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
items: [
        {
  description: 'Lucasfilm is one of the worlds leading entertainment companies and home to the legendary Star Wars and Indiana Jones franchises.',
  headquarters: 'San Francisco, California, USA',
  homepage: 'http://www.lucasfilm.com',
  id: 1,
  poster_path: '/o86DbpburjxrqAzEDhXZcyE8pDb.png',
  name: 'Lucasfilm',
  origin_country: 'US',
  parent_company: null
},
{
  description: "Pixar Animation Studios is an American computer animation studio based in Emeryville, California, a subsidiary of The Walt Disney Studios. ",
  headquarters: "Emeryville, California, USA",
  ho1mepage: "http://www.pixar.com",
  id: 3,
  poster_path: "/1TjvGVDMYsj6JBxOAkUHpPEwLf7.png",
  name: "Pixar",
  origin_country: "US",
},
{
  description: "Paramount Pictures is the one of oldest film studios in the world. Currently is an American film studio and subsidiary of ViacomCBS.",
  headquarters: "Hollywood, California, USA",
  homepage: "http://www.paramount.com/",
  id: 4,
  poster_path: "/fycMZt242LVjagMByZOLUGbCvv3.png",
  name: "Paramount",
  origin_country: "US",
},
{
  description: "Columbia Pictures Industries, Inc. (CPII) is an American film production and distribution company. Columbia Pictures now forms part of the Columbia TriStar Motion Picture Group, owned by Sony Pictures Entertainment, a subsidiary of the Japanese conglomerate Sony. It is one of the leading film companies in the world, a member of the so-called Big Six. It was one of the so-called Little Three among the eight major film studios of Hollywood's Golden Age.",
  headquarters: "Culver City, California, USA",
  homepage: "http://www.sonypictures.com",
  id: 5,
  poster_path: "/71BqEFAF4V3qjjMPCpLuyJFB9A.png",
  name: "Columbia Pictures",
  origin_country: "US",
  parent_company: null
},
]      
    }
  },
  methods: {
    mobileCheck() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check
},    
    openDorm (id,slug) {
      let dorm  = this.items.find(function (dorm) { return dorm.id == id } )
      if(dorm.branch_count > 0 && dorm.center_slug) {
          var self = this
        // const url = self.$attrs.redirect ? `/site/dorm/detail/old/${dormID}` : `/site/dorm/detail/${this.$route.params.id}`    
        window.localStorage.setItem('branchnumber', dorm.branch_count) 
           window.localStorage.setItem('branchedDormTitle', dorm.center_name)
          window.localStorage.setItem('branchDescription', dorm.description)
             window.localStorage.setItem('branchKeywords', dorm.keywords)
             window.localStorage.setItem('branchedDormId', dorm.id)
             window.localStorage.setItem('dormLogo', dorm.logo)
             window.localStorage.setItem('dormWeb', dorm.web)
             window.localStorage.setItem('slug', dorm.center_slug)
             window.localStorage.setItem('city_id', dorm.city_id)
             if(dorm.center_description) {
             window.localStorage.setItem('center_description', dorm.description)
             window.localStorage.setItem('center_keywords', dorm.keywords)
             }

             // let dorm = this.string_to_slug(this.dorm.slug)
             let route = { name: 'Branch', params: { dorm: dorm.center_slug, id:dorm.id } }
             this.$router.push(route)
      }
      else {
      window.localStorage.setItem('dormid', id)
      // let url = window.location.origin + 
      let url = 'http://www.holywoodskyline.com/' + slug + '-y-' + id
      window.localStorage.setItem('url', url)
      window.localStorage.setItem('slug', slug + '-y-' + id)
      //window.localStorage.setItem('description', this.dorm.description)
      //window.localStorage.setItem('name', this.dorm.name)
      if(this.mobileCheck()) {
        window.open(window.location.origin + '/' + slug + '-y-' + id, '_self')
      } else {
        window.open(window.location.origin + '/' + slug + '-y-' + id, '_blank')
      }    
      }

  
      
    },    
    getDorms () {
      let self = this
      //axios.get('/site/home/slider-promote-dorms')
      axios.get('/3/movie/popular?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US&page=1')

        .then(response => {
          self.items = response.data.results
          self.dorm = response.data.results
/*           response.data.forEach((data) => { 
            if(data.branch_count > 0 && data.center_slug) {
       const url = `/site/dorm/branches/${data.id}`     
       axios.get(url)
         .then(response => {

           // let dorm  = this.items.find(function (dorm) { return dorm.name == data.name } )


            self.items.forEach((item) => { 
            if(data.name === item.name) {
            item.name = response.data.center_name
            }
            })    
        })
            }
            })  */


        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  created () {
    //this.getDorms()
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/components/hero-slider";
</style>
